var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWorkflowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6666_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89999 2.91663C9.33334 2.72218 8.39299 4.82412 5.66867 7.98431C3.5 10.5 5.44445 11.375 6.74661 11.375H9.35753M4.66667 2.91663C4.66667 3.88312 3.88317 4.66663 2.91667 4.66663C1.95017 4.66663 1.16667 3.88312 1.16667 2.91663C1.16667 1.95013 1.95017 1.16663 2.91667 1.16663C3.88317 1.16663 4.66667 1.95013 4.66667 2.91663ZM12.8333 11.0833C12.8333 12.0498 12.0498 12.8333 11.0833 12.8333C10.1168 12.8333 9.33334 12.0498 9.33334 11.0833C9.33334 10.1168 10.1168 9.33329 11.0833 9.33329C12.0498 9.33329 12.8333 10.1168 12.8333 11.0833Z",
    stroke: "#699D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6666_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkflowBtn);
export default __webpack_public_path__ + "static/media/add-workflow-btn.ca1f1a7a.svg";
export { ForwardRef as ReactComponent };